export enum ExternalUserEventSource {
  Import = 1,
  Manual = 2,
  Backfill = 3 //Record was created as part of backfill. Jira ticket: PLA-935
}
